module.exports = "/assets/images/party.png";